export default "__VITE_ASSET__DFWD8e_Z__"